/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Next_MarkerInputs */

const en_shortcut_keys_desc_next_marker = /** @type {(inputs: Shortcut_Keys_Desc_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to next marker`)
};

const fr_shortcut_keys_desc_next_marker = /** @type {(inputs: Shortcut_Keys_Desc_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller au marqueur suivant`)
};

const de_shortcut_keys_desc_next_marker = /** @type {(inputs: Shortcut_Keys_Desc_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum nächsten Marker gehen`)
};

const it_shortcut_keys_desc_next_marker = /** @type {(inputs: Shortcut_Keys_Desc_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai al marcatore successivo`)
};

const ru_shortcut_keys_desc_next_marker = /** @type {(inputs: Shortcut_Keys_Desc_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейдите к следующей отметке`)
};

const es_shortcut_keys_desc_next_marker = /** @type {(inputs: Shortcut_Keys_Desc_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al siguiente marcador`)
};

const zh_cn2_shortcut_keys_desc_next_marker = /** @type {(inputs: Shortcut_Keys_Desc_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往下一个标记点`)
};

const ja_shortcut_keys_desc_next_marker = /** @type {(inputs: Shortcut_Keys_Desc_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のマーカーへ移動`)
};

const hi_shortcut_keys_desc_next_marker = /** @type {(inputs: Shortcut_Keys_Desc_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगले मार्कर पर जाएं`)
};

const pt_pt2_shortcut_keys_desc_next_marker = /** @type {(inputs: Shortcut_Keys_Desc_Next_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vá para o próximo marcador.`)
};

/**
* | output |
* | --- |
* | "Go to next marker" |
*
* @param {Shortcut_Keys_Desc_Next_MarkerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_next_marker = /** @type {((inputs?: Shortcut_Keys_Desc_Next_MarkerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Next_MarkerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_next_marker(inputs)
	if (locale === "de") return de_shortcut_keys_desc_next_marker(inputs)
	if (locale === "it") return it_shortcut_keys_desc_next_marker(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_next_marker(inputs)
	if (locale === "es") return es_shortcut_keys_desc_next_marker(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_next_marker(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_next_marker(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_next_marker(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_next_marker(inputs)
	return en_shortcut_keys_desc_next_marker(inputs)
});